import styled from "styled-components";
import { Color, Font, breakpoints } from "@/shared/Constants";

export const MenuTop = styled.ul`
  display: flex;
  flex-direction: row;
  padding: 0 15px;
  margin-bottom: 3px;
  align-items: center;
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  min-width: max-content !important;
  /* width */
  ::-webkit-scrollbar {
    width: 0px;
    height: 0;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: none;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: none;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: none;
  }
  .contentMenu {
    width: max-content !important;
  }
  li {
    margin-top: 4px;
    margin-right: 10px;
    display: flex;
    justify-content: center;
    a {
      ${Font.sansSemiBold};
      color: ${Color.grey};
      display: block;
      font-size: 13px;
      transition: all 0.6s ease 0s;
      text-transform: uppercase;
    }
    .tooltip {
      min-height: 24px;
      min-width: 82px;
      background-color: #39dff5;
      color: #000;
      text-align: center;
      border-radius: 3px;
      padding: 6px 8px;
      position: absolute;
      z-index: 1;
      margin: auto;
      margin-top: 21px;
      box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);
      ${Font.sansRegular};
      font-size: 12px;

      text-transform: uppercase;
      ::after {
        content: "";
        position: absolute;
        border-width: 5px;
        border-style: solid;
        margin-left: -5px;
        bottom: 100%;
        left: 50%;
        border-color: transparent transparent #39dff5 transparent;
      }
    }
    &.tienda-clarin {
      display: flex;
      align-items: center;
      > div {
        width: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        svg {
          width: auto;
          height: 16px !important;
          color: ${Color.grey};
        }
      }
      .tooltip.tooltip-direction-right {
        position: inherit;
        display: flex;
        min-width: max-content !important;
        margin-top:0;
        margin-left: 0.25rem;
        border-radius: 20px;
        box-shadow: none;
        font-size: 10px;
        &::after {
          display: none;
        }
      }
    }
  }
`;
